<template>
  <div class="my-6 max-w-full overflow-x-auto table relative">
    <table>
      <slot />
    </table>
  </div>
</template>

<style lang="postcss" scoped>
table {
  @apply w-full table-auto text-left text-sm leading-5;
}

.table:has(.no-overflow) {
  @apply overflow-visible;
}

.table-scroll-x table {
  @apply w-max;
}
</style>
